import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector   : 'cowtux-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls  : ['./confirm-dialog.component.scss']
})
export class COWTUXConfirmDialogComponent
{
    public confirmMessage: string;

    /**
     * Constructor
     *
     * @param {MatDialogRef<COWTUXConfirmDialogComponent>} dialogRef
     */
    constructor(
        public dialogRef: MatDialogRef<COWTUXConfirmDialogComponent>
    )
    {
    }

}
